import { secureDelete, secureGet, securePost, securePut } from "../../Config/ApiConfig";

export const getUsers = async ({ page, size, sort_by, sort_direction, search_string, filters, signal }) => {
    let url = `/users?page=${page}&page_size=${size}`;
    if (sort_by) {
        url += `&sort_by=${sort_by}`;
    }
    if (sort_direction) {
        url += `&sort_direction=${sort_direction}`;
    }
    if (search_string) {
        url += `&search_string=${search_string}`;
    }
    if (filters) {
        const encoded = encodeURIComponent(JSON.stringify(filters));
        url += `&filters=${encoded}`;
    }
    const { data } = await secureGet(url, signal ? { signal } : {})
    return data;
};

export const resendVerificationEmail = async (id) => {
    const { data } = await securePost(`/users/${id}/resend-verification-email`);
    return data;
};

export const getProducts = async () => {
    const { data } = await secureGet('/payments/products')
    return data;
};

export const getUser = async (id) => {
    const { data } = await secureGet(`/users/${id}`)
    return data;
};
export const createUser = async (body) => {
    const { data } = await securePost(`/users`, body)
    return data;
};
export const getUserToken = async (id) => {
    const { data } = await secureGet(`/users/${id}/generate-tokens`)
    return data;
};

/*for post and put body:
{
    "first_name": "Jane",
    "last_name": "Smith",
    "email": "jane.smith@example.com",
    "password": "Password@123",
    "is_admin": true,
    "is_verified": true,
}
*/

export const updateUser = async (id, body) => {
    const { data } = await securePut(`/users/${id}`, body)
    return data;
};

export const deleteUser = async (id) => {
    const { data } = await secureDelete(`/users/${id}`)
    return data;
};

export const deleteUserProfilePicture = async (id) => {
    const { data } = await secureDelete(`/users/${id}/profile-picture`);
    return data;
};